const localStorage = {
    sessionId: "sessionId",  
    userData: "userData",
    fcmToken: "FCMTOKEN",
  };




  const strings = {
    localStorage,
  };
  
  export default strings;